import { render, staticRenderFns } from "./proof-list.vue?vue&type=template&id=88e0ea6a&scoped=true&"
import script from "./proof-list.vue?vue&type=script&lang=js&"
export * from "./proof-list.vue?vue&type=script&lang=js&"
import style0 from "./proof-list.vue?vue&type=style&index=0&id=88e0ea6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e0ea6a",
  null
  
)

export default component.exports